/**
 * TanStack Query hooks — demandes d'information assureur (chunk 9.AN.1).
 *
 *   GET  /v1/insurer-information-requests?project_id=
 *   POST /v1/insurer-information-requests
 *
 * L'interface ne décide rien : c'est le serveur qui refuse d'ouvrir une demande sur
 * une information qui n'est pas absente, et qui tranche le double clic par un index
 * partiel. Le composant se contente de proposer le geste et d'afficher l'état.
 */

import type { InsurerInformationRequestRow } from "@kollectivia/shared";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";

const CLE = ["insurer-information-requests"] as const;

export function useInsurerInformationRequests(projectId: string | undefined) {
  return useQuery({
    queryKey: [...CLE, projectId],
    queryFn: () =>
      api.get<InsurerInformationRequestRow[]>(
        `/v1/insurer-information-requests?project_id=${projectId}`,
      ),
    enabled: !!projectId,
    placeholderData: (prev) => prev,
  });
}

export type DemandeVars = { recipient_id: string; field_path: string };

export function useCreateInsurerInformationRequest() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: DemandeVars) =>
      api.post<InsurerInformationRequestRow>("/v1/insurer-information-requests", vars),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: CLE });
      // La cellule elle-même ne change pas — elle reste `not_provided` tant que
      // l'assureur n'a pas répondu — mais l'état de la demande, si.
    },
  });
}
